'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Checkbox } from '@/components/ui/checkbox/checkbox.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { SearchApiFacilityExam } from '@/app/(main)/(pages)/_types/search-api-response.type';
import { currencyFormatter } from '@/utils/formatters/currency';

interface LaboratoryExamItemProps {
  exam: SearchApiFacilityExam;
  checked: boolean;
  disabled?: boolean;
  onToggle(exam: SearchApiFacilityExam): void;
}

export function LaboratoryExamItem({ exam, checked, disabled = false, onToggle }: LaboratoryExamItemProps) {
  return (
    <div
      data-testid={`${DataTestIdEnum.BRANCH_LABORATORY_EXAM_ITEM}-${exam.id}`}
      className="border-b border-gray-300 px-6 py-5"
    >
      <Checkbox
        id={`laboratory-exam-${exam.id}`}
        align="start"
        checked={checked}
        disabled={disabled}
        onCheckedChange={() => onToggle(exam)}
      >
        <span className="flex flex-col">
          <Typography variant={TypographyVariant.BODY_TEXT} as="span" className="font-semibold text-gray-700">
            {exam.name}
          </Typography>
          <Typography variant={TypographyVariant.BODY_TEXT} as="span" className="font-bold text-green-500">
            {currencyFormatter(exam.price)}
          </Typography>
        </span>
      </Checkbox>
    </div>
  );
}
